export type LastApiRequestSnapshot = {
    ts: number;
    method: string;
    url: string;
    status?: number;
    error?: string;
};

let last: LastApiRequestSnapshot | undefined;
const subs = new Set<() => void>();

export const isDebugBarEnv = (): boolean => {
    const v = (process.env.REACT_APP_DEBUG_BAR || "").toLowerCase().trim();
    return v === "1" || v === "true";
};

export const setLastApiRequest = (snapshot: LastApiRequestSnapshot): void => {
    if (!isDebugBarEnv()) return;
    last = snapshot;
    subs.forEach((fn) => fn());
};

export const getLastApiRequest = (): LastApiRequestSnapshot | undefined => last;

export const subscribeLastApiRequest = (fn: () => void): (() => void) => {
    subs.add(fn);
    return () => subs.delete(fn);
};
